<template>
  <div class="checkout-auth">
    <div class="checkout-auth-info">
      <f-sprite-icon :icon-link="$options.icons.ClubCard.id" />
      Используйте бонусы Клубной программы и получайте дополнительные скидки
    </div>
    <div class="checkout-auth-buttons">
      <ui-button text="Войти и использовать бонусы" @click="login" />
      <ui-button secondary text="Зарегистрироваться" @click="login" />
    </div>
  </div>
</template>

<script>
/* Icons */
import ClubCard from '../../assets/icons/club-card.multi.svg';
export default {
  name: 'checkout-auth',

  icons: {
    ClubCard,
  },

  methods: {
    login() {
      this.$f.login().catch(() => {});
    },
  },
}
</script>

<style lang="scss">
.checkout-auth {
  background: $white;
  border: 1px solid $gray_lu;
  border-radius: 4px;
  padding: 12px;
  margin-bottom: 12px;
  &-info {
    font-weight: 600;
    font-size: 14px;
    line-height: 20px;
    .sprite-icon {
      display: none;
    }
  }
  &-buttons {
    display: flex;
    flex-direction: column;
    .ui-button {
      margin-top: 12px;
    }
  }
}

@include breakpoint("tablet") {
  .checkout-auth {
    padding: 24px;

    &-info {
      font-size: 16px;
      line-height: 24px;
      display: flex;
      justify-content: center;
      .sprite-icon {
        display: block;
        width: 36px;
        height: 24px;
        margin-right: 12px;
      }
    }
  }
}

@include breakpoint("desktop") {
  .checkout-auth {
    flex-direction: row;

    &-buttons {
      margin-top: 8px;
      flex-direction: row;
      justify-content: center;

      & > *:not(:first-child) {
        margin-left: 16px;
      }
    }
  }
}
</style>
